import React, { useMemo } from 'react';
import PageContent from 'components/subscriber/employee-profile';
import {
  EmployeeProfilePageStore,
  EmployeeProfilePageStoreContext,
} from 'store/pages/subscriber/employee-profile/pageStore';

const EmployeeProfilePage: React.FC = () => {
  const pageStore = useMemo(() => new EmployeeProfilePageStore(), []);

  return (
    <EmployeeProfilePageStoreContext.Provider value={pageStore}>
      <PageContent />
    </EmployeeProfilePageStoreContext.Provider>
  );
};

export default EmployeeProfilePage;
